import { gql } from "@apollo/client";

export const USER_POOL_GET_PRESIGNED_URL_S3 = gql`
  query GetPresignedUrlS3($filename: String, $filepath: String) {
    getPresignedUrlS3(filename: $filename, filepath: $filepath)
  }
`;
